import React, { useState } from 'react';
import { FadeIn } from './FadeIn';
import { motion, AnimatePresence } from 'framer-motion';
import { ChevronDownIcon } from 'lucide-react';
export function FAQ() {
  const faqs = [{
    q: '¿Es esto "Ley de Atracción"?',
    a: 'Es la raíz bíblica de la manifestación: fe con obras y visión clara.'
  }, {
    q: '¿Cuánto tardaré en ver resultados?',
    a: 'La paz mental es inmediata; la provisión corre hacia quien tiene la visión escrita.'
  }, {
    q: '¿Necesito saber mucho de la Biblia?',
    a: 'No, el manual te da las citas y pasos exactos.'
  }, {
    q: '¿Es un pago único?',
    a: 'Sí, acceso de por vida por solo $6.36.'
  }];
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  return <section className="py-24 bg-parchment border-t border-parchment-dark" data-id="element-31">
      <div className="container mx-auto px-4" data-id="element-32">
        <div className="max-w-3xl mx-auto" data-id="element-33">
          <FadeIn data-id="element-34">
            <h2 className="text-3xl md:text-4xl font-bold text-center text-ink mb-12" data-id="element-35">
              Preguntas Frecuentes
            </h2>
          </FadeIn>

          <div className="space-y-4" data-id="element-36">
            {faqs.map((faq, index) => <FadeIn key={index} delay={index * 0.1} data-id="element-37">
                <div className="bg-white rounded-xl border border-parchment-dark overflow-hidden shadow-sm" data-id="element-38">
                  <button onClick={() => setOpenIndex(openIndex === index ? null : index)} className="w-full px-6 py-5 text-left flex justify-between items-center focus:outline-none" data-id="element-39">
                    <span className="font-bold text-navy font-serif text-lg pr-4" data-id="element-40">
                      {faq.q}
                    </span>
                    <ChevronDownIcon className={`w-5 h-5 text-gold transition-transform duration-300 ${openIndex === index ? 'rotate-180' : ''}`} data-id="element-41" />
                  </button>

                  <AnimatePresence data-id="element-42">
                    {openIndex === index && <motion.div initial={{
                  height: 0,
                  opacity: 0
                }} animate={{
                  height: 'auto',
                  opacity: 1
                }} exit={{
                  height: 0,
                  opacity: 0
                }} transition={{
                  duration: 0.3
                }} data-id="element-43">
                        <div className="px-6 pb-5 text-charcoal border-t border-gray-50 pt-4" data-id="element-44">
                          {faq.a}
                        </div>
                      </motion.div>}
                  </AnimatePresence>
                </div>
              </FadeIn>)}
          </div>
        </div>
      </div>
    </section>;
}